import { SpineAdapter } from "../SpineAdapter";
import { SpineMeshUtils } from "../mesh/SpineMeshUtils";
export class SkinRenderUpdate {
    constructor(owner, skinAttach) {
        this.currentMaterials = [];
        this.cacheMaterials = [];
        this.vChanges = [];
        this.vertexBones = 0;
        this.owner = owner;
        this.name = skinAttach.name;
        this.hasNormalRender = skinAttach.hasNormalRender;
        this.vertexBones = skinAttach.vertexBones;
        this.skinAttachType = skinAttach.type;
    }
    getMaterialByName(name, blendMode) {
        return this.templet.getMaterial(this.templet.getTexture(name), blendMode);
    }
    renderUpdate(skindata, frame, lastFrame) {
        const renderNode = this.owner._nodeOwner;
        let needUpdate = false;
        if (skindata.isDynamic) {
            needUpdate = this.updateDynamicRender(skindata, frame, lastFrame, renderNode);
        }
        else {
            needUpdate = this.handleRender(skindata, frame, renderNode, skindata.getMesh());
        }
        if (needUpdate)
            renderNode._updateRenderElements();
    }
    updateDynamicRender(skindata, frame, lastFrame, renderNode) {
        let mesh = this.owner.getDynamicMesh(skindata.vb.vertexDeclaration);
        let currentChanges = this.vChanges;
        let frameData = skindata.getFrameData(frame);
        let isFirst = frame < 0;
        let needUpload = false;
        if (isFirst) {
            this._resetVertexBuffset(skindata);
            currentChanges.length = 0;
        }
        for (let f = lastFrame + 1; f <= frame; f++) {
            let frameData = skindata.getFrameData(f);
            let frameChanges = frameData.vChanges;
            if (frameChanges) {
                for (const change of frameChanges) {
                    if (!currentChanges.includes(change)) {
                        currentChanges.push(change);
                    }
                }
            }
        }
        for (let i = currentChanges.length - 1; i >= 0; i--) {
            let change = currentChanges[i];
            if (change.apply(frame, skindata.vb, this.owner._skeleton.slots)) {
                needUpload = true;
            }
            else {
                currentChanges.splice(i, 1);
            }
        }
        if (needUpload || isFirst) {
            this.uploadVertexBuffer(skindata.vb, mesh);
        }
        if (frameData.ib || isFirst) {
            this.uploadIndexBuffer(frameData, mesh);
        }
        let needUpdateMesh = SpineMeshUtils._updateSpineSubMesh(mesh, frameData);
        return this.handleRender(skindata, frame, renderNode, mesh, needUpdateMesh);
    }
    handleRender(skindata, frame, renderNode, mesh, forceUpdateMesh = false) {
        let frameData = skindata.getFrameData(frame);
        let needUpdate = false;
        let mulitRenderData = frameData.mulitRenderData;
        if (mulitRenderData) {
            let mats = this.cacheMaterials[mulitRenderData.id] || this.createMaterials(mulitRenderData);
            if (this.currentMaterials !== mats) {
                renderNode._updateMaterials(mats);
                needUpdate = true;
                this.currentMaterials = mats;
            }
        }
        return !renderNode._onMeshChange(mesh, forceUpdateMesh) || needUpdate;
    }
    createMaterials(mulitRenderData) {
        let mats = mulitRenderData.renderData.map(data => this.getMaterialByName(data.textureName, data.blendMode));
        this.cacheMaterials[mulitRenderData.id] = mats;
        return mats;
    }
    uploadIndexBuffer(frameData, mesh) {
        let indexData = frameData.ib;
        let indexbuffer = mesh._indexBuffer;
        indexbuffer.indexType = frameData.type;
        indexbuffer.indexCount = indexData.length;
        indexbuffer._setIndexDataLength(indexData.byteLength);
        indexbuffer._setIndexData(indexData, 0);
    }
    uploadVertexBuffer(vbCreator, mesh) {
        let vertexBuffer = mesh.vertexBuffers[0];
        let vblen = vbCreator.vbLength * 4;
        vertexBuffer.setDataLength(vbCreator.maxVertexCount * vbCreator.vertexSize * 4);
        vertexBuffer.setData(vbCreator.vb.buffer, 0, 0, vblen);
    }
    init(skeleton, templet, renderNode) {
        this.templet = templet;
        if (this.hasNormalRender) {
            this._renderer = SpineAdapter.createNormalRender(templet);
        }
    }
    render(time) {
    }
    _resetVertexBuffset(skindata) {
        let slots = this.owner._skeleton.slots;
        let map = skindata.vb.slotVBMap;
        let renderDatas = skindata.renderDatas;
        let resetSlots = new Set();
        renderDatas.forEach(data => {
            if (data.vChanges) {
                for (const change of data.vChanges) {
                    resetSlots.add(change.slotId);
                }
            }
        });
        resetSlots.forEach(slotId => {
            var _a;
            let slot = slots[slotId];
            if (slot && slot.attachment) {
                let attach = (_a = map.get(slotId)) === null || _a === void 0 ? void 0 : _a.get(slot.attachment.name);
                if (attach) {
                    skindata.vb.resetVB(attach.attachment);
                }
            }
        });
    }
    destroy() {
        if (this.hasNormalRender) {
            this._renderer.destroy();
        }
    }
}
